import { action, flow, makeObservable, observable } from 'mobx';

import { apiFetcher } from '../utils/fetch';
import { updateItems } from './utils';

export default class Reminder {
  constructor() {
    this.items = [];
    this.upcoming = [];

    makeObservable(this, {
      items: observable,
      upcoming: observable,
      fetch: flow,
      fetchUpcoming: flow,
      create: flow,
      update: flow,
      dismiss: flow,
      delete: flow
    });
  }

  *fetch(params = {}) {
    try {
      const search = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v) search.append(k, v);
      });
      const qs = search.toString();
      const response = yield apiFetcher().get(
        `/reminders${qs ? `?${qs}` : ''}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *fetchUpcoming(days = 60) {
    try {
      const response = yield apiFetcher().get(
        `/reminders/upcoming?days=${days}`
      );
      this.upcoming = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *create(reminder) {
    try {
      const response = yield apiFetcher().post('/reminders', reminder);
      this.items = updateItems(response.data, this.items);
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *update(reminder) {
    try {
      const response = yield apiFetcher().patch(
        `/reminders/${reminder._id}`,
        reminder
      );
      this.items = updateItems(response.data, this.items);
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *dismiss(id) {
    try {
      const response = yield apiFetcher().post(`/reminders/${id}/dismiss`);
      this.items = updateItems(response.data, this.items);
      this.upcoming = this.upcoming.filter((r) => r._id !== id);
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *delete(ids) {
    try {
      yield apiFetcher().delete(`/reminders/${ids.join(',')}`);
      this.items = this.items.filter((r) => !ids.includes(r._id));
      this.upcoming = this.upcoming.filter((r) => !ids.includes(r._id));
      return { status: 200 };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }
}
